import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;

const SoporteReemplazoService = {
  // 1. Subir soporte de reemplazo
  upload: async (formData) => {
    const url = `${baseUrl}/api/documentos_reemplazos`;
    const response = await axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // 2. Procesar un soporte por codUnico
  processByCodUnico: async (codUnico) => {
    const url = `${baseUrl}/api/documentos_reemplazos/procesar/${codUnico}`;
    const response = await axios.post(url);
    return response.data;
  },


  // 3. Listar todos los soportes
  list: async (ruta) => {
    const url = `${baseUrl}/api/documentos_reemplazos`;
    const response = await axios.get(url, {
      params: { ruta }
    });
    return response.data;
  },

  // 4. Procesar todos los soportes pendientes
  processAll: async () => {
    const url = `${baseUrl}/api/documentos_reemplazos/procesar`;
    const response = await axios.post(url);
    return response.data;
  },

  // 5. Traer archivos reemplazables (con query param ruta)
  getArchivosReemplazables: async (ruta) => {
    const url = `${baseUrl}/api/documentos_reemplazos/archivos`;
    const response = await axios.get(url, {
      params: { ruta }
    });
    return response.data;
  },

  // 6. Histórico completo de reemplazos
  historico: async (codUnico) => {
    const url = `${baseUrl}/api/documentos_reemplazos/historico`;
    const response = await axios.get(url, {
      params: codUnico ? { codUnico } : {}
    });
    return response.data;
  },

  // 7. Traer proyectos
  proyectos: async () => {
    const url = `${baseUrl}/api/documentos_reemplazos/proyecto`;
    const response = await axios.get(url);
    return response.data;
  },
};

export default SoporteReemplazoService;
